// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1Tg9s","label":"button-module--label--2jJsB","elevated":"button-module--elevated--3BMYH","disabled":"button-module--disabled--2yZ3X"};